/**
 * @package   ats
 * @copyright Copyright (c)2011-2026 Nicholas K. Dionysopoulos / Akeeba Ltd
 * @license   GNU General Public License version 3, or later
 */

"use strict";

if (Joomla.getOptions("ats.log.tooBig", false))
{
    [].slice.call(document.querySelectorAll("#showlog")).forEach(function (el) {
        el.addEventListener('click', function (event) {
            event.preventDefault();

            var iFrame       = document.createElement("iframe");
            var iFrameHolder = document.getElementById("iframe-holder");

            iFrame.setAttribute("class", "w-100 h-100")
            iFrame.setAttribute("src", Joomla.getOptions("ats.log.src"))

            iFrameHolder.style.display = "block";

            iFrameHolder.appendChild(iFrame);

            event.currentTarget.style.display = 'none';
        });

    });


}